export enum Icons {
  "account_circle",
  "add",
  "arrow_back",
  "arrow_forward",
  "arrow_back_ios",
  "arrow_forward_ios",
  "autorenew",
  "chat",
  "close",
  "corporate_fare",
  "delete",
  "edit",
  "expand_more",
  "file_upload",
  "info",
  "location_on",
  "logout",
  "search",
  "warning",
  "draft",
  "send",
  "mail",
  "tune",
  "print"
}

export enum ButtonType {
  "primary",
  "secondary",
  "tertiary",
}

export enum ButtonSize {
  "small",
  "medium",
  "large",
}

export type ButtonBaseProps = {
  buttonType?: keyof typeof ButtonType;
  size?: keyof typeof ButtonSize;
  text?: string;
  icon?: keyof typeof Icons;
  setIconLast?: boolean;
  style?: string;
  className?: string;
  iconModifierClass?: string;
  textModifierClass?: string;
  alignButtonLeft?: boolean;
  trackingName: string;
};
